import { useTranslations } from "next-intl"

/** How long a kind of credits lasts, shown wherever they are bought or moved; nothing when they never expire. */
export function CreditLifetimeNote({ months, subject, className }: { months: number | null; subject: string; className?: string }) {
  const tUi = useTranslations("Billing.BillingCreditLifetimeNote")

  if (months === null) return null
  const text = tUi("creditLifetime", { subject, months })
  return <p className={className}><span key={text}>{text}</span></p>
}
